import React from 'react'
import Helmet from 'react-helmet'

const DEFAULT_TITLE = "IM Online Shop | Premium Sneakers, Shoes, Loafers and Boots";
const DEFAULT_DESCRIPTION = "Shop premium sneakers, sports shoes, loafers, boots and everyday footwear at IM Online Shop with trusted quality, secure payments and easy support.";
const DEFAULT_IMAGE = "/output-onlinepngtools.png";
const SITE_NAME = "IM Online Shop";

function MetaTag({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  keywords,
  image = DEFAULT_IMAGE,
  url,
  type = "website",
  robots = "index, follow",
  canonical,
  schema,
}) {
  const pageUrl = canonical || url || (typeof window !== "undefined" ? window.location.href : "https://imonline.shop/");
  const absoluteImage = image && image.startsWith("http")
    ? image
    : `https://imonline.shop${image && image.startsWith("/") ? image : `/${image || ""}`}`;

  return (
   <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    {keywords && <meta name="keywords" content={keywords} />}
    <meta name="robots" content={robots} />
    <link rel="canonical" href={pageUrl} />

    <meta property="og:site_name" content={SITE_NAME} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:type" content={type} />
    <meta property="og:url" content={pageUrl} />
    <meta property="og:image" content={absoluteImage} />
    <meta property="og:locale" content="en_IN" />

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={absoluteImage} />

    {schema && (
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    )}
   </Helmet>
  )
}

export default MetaTag
